import { AxiosService } from './axiosService';

// Matches the relay's HttpClient.Timeout — large CSV uploads can take minutes.
export const BULK_UPLOAD_TIMEOUT_MS = 300000;

export class UtilityMeterService extends AxiosService {
    async getUtilityMeters(utilityAccountId, type = null) {
        try {
            const params = { utilityAccountId };
            if (type) params.type = type;
            const { data } = await this.axios.get('/utilitymeters', { params });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async createUtilityMeter(utilityAccountId, meter) {
        try {
            const { data } = await this.axios.post(`/utilitymeters/${utilityAccountId}`, meter);
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async updateUtilityMeter(utilityMeterId, meter) {
        try {
            const { data } = await this.axios.put(`/utilitymeters/${utilityMeterId}`, meter);
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    async deleteUtilityMeter(utilityMeterId) {
        try {
            const { data } = await this.axios.delete(`/utilitymeters/${utilityMeterId}`);
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }

    // NOTE: like the rest of this service, a swallowed 401 returns null —
    // callers must treat a null result as a failed upload, never a success.
    async uploadMeterData(meterId, dataArray) {
        try {
            const { data } = await this.axios.post(`/utilitymeters/${meterId}/data/bulk`, dataArray, {
                timeout: BULK_UPLOAD_TIMEOUT_MS,
            });
            return data;
        } catch (e) {
            if (e?.response?.status !== 401) throw e;
        }
        return null;
    }
}

export const utilityMeterService = new UtilityMeterService();
